module.exports = __webpack_public_path__ + "img/fly-inactive.24cbcec6.svg";